// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08eb4304","455":"9adc22e2","488":"e7d7ae3a"}[chunkId] + ".chunk.js";
};